export default __webpack_public_path__ + "static/media/developer-mode.afd317d1.svg";